import MenuStep from './components/MenuStep/MenuStep'
import styled from './DesktopMenu.module.scss'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../module/rootStore'

const DesktopMenu = () => {
  const { stepsSetting } = useStore().StepsStore

  return (
    <div className={styled.wrapper}>
      {stepsSetting &&
        stepsSetting.map((step, index) => {
          return <MenuStep stepData={step} stepNumber={index} key={index} />
        })}
      <div className={styled.step}>Ingreso de dinero</div>
    </div>
  )
}

export default observer(DesktopMenu)
